import React, { Component } from "react";
import "react-toastify/dist/ReactToastify.css";
import SimpleModalWrapped from "../../common/Modal";
import TextField from "../../common/TextField";
import SingleSelect from "../../common/SingleSelect";
import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";

const styles = () => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
});

class AddModelModal extends Component {
  render() {
    const makeValue = this.props.form?.makeName
      ? {
          id: this.props.form.makeName,
          key: this.props.form.makeName,
          label: this.props.form.makeName,
          value: this.props.form.makeName,
        }
      : "";

    return (
      <SimpleModalWrapped
        {...this.props}
        visable
        isButtonVisable
        title={this.props.title}
        formSubmit={this.props.formSubmit}
        modalControle={this.props.modalControle}
        btnclosetext={this.props.translate("sharedBack")}
        buttonText={this.props.buttonText}
        isVisableBtn={this.props.isVisableCreateBtn}
        content={
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12} style={{ position: "relative", zIndex: 99 }}>
              <SingleSelect
                array={this.props.allMakes || []}
                serverPaginated
                isClearable
                isLoading={this.props.makesLoading}
                id="makeName"
                selectName="makeName"
                label={this.props.translate("makeName")}
                onSearchChange={this.props.searchMakesList}
                onMenuScrollToBottom={this.props.loadMoreMakes}
                value={makeValue}
                handleChange={this.props.handleMakeChange}
                canRemove={true}
                canAssign={true}
                menuPlacement="auto"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <TextField
                id="modelName"
                label={this.props.translate("modelName")}
                type="text"
                placeholder=""
                value={this.props.form?.modelName || ""}
                onChange={this.props.handleChange("modelName")}
                variant="outlined"
                margin="dense"
                fullWidth
                required
              />
            </Grid>
          </Grid>
        }
      />
    );
  }
}

export default withStyles(styles)(AddModelModal);
